import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-visibility"
export default class extends Controller {
  static targets = ["field", "shower", 'hider']

  show() {
    this.showerTarget.classList.add('hidden')
    this.hiderTarget.classList.remove('hidden')
    this.fieldTarget.type = 'text'
  }

  hide() {
    this.showerTarget.classList.remove('hidden')
    this.hiderTarget.classList.add('hidden')
    this.fieldTarget.type = 'password'
  }
}
